/* eslint-disable eqeqeq */
import React, { useState, useEffect } from 'react';
import style from './import.module.css';
import { InboxOutlined } from '@ant-design/icons';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import type { UploadProps } from 'antd';
import { message, Upload, Button, notification, Spin, Progress, Modal, Radio } from 'antd';
import { FormSelect } from '../../components/Basic/FormInput';
import * as yup from 'yup';
import Header from '../../components/Header/header';
import { hasPermission } from '../../utils/premission';
import { PERMISSIONS } from '../../utils/constant/permissions';
import { getDecodedToken } from '../../utils/auths';
import { apiFetch } from '../../utils/auth/apiFetch';

const { Dragger } = Upload;
const API_URL = process.env.REACT_APP_API_URL;
console.log(API_URL)

const validationSchema = yup.object().shape({
    templateType: yup.string().required('TemplateType is required'),
});

const MultiViewTable: React.FC = () => {
    const [spinning, setSpinning] = useState(false);
    const [fileList, setFileList] = useState<any[]>([]);
    const [getIDs, setGetIDs] = useState<any[]>([]);
    const [backgroundText, setBackgroundText] = useState<string>('');
    const [uploadProgress, setUploadProgress] = useState<number>(0);
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [uploadStatus, setUploadStatus] = useState<'success' | 'exception' | 'active' | 'normal'>('normal');
    const [action, setAction] = useState<'override' | 'skip' | null>(null);



    const {
        control,
        formState: { errors },
        handleSubmit,
        getValues,
    } = useForm({
        defaultValues: {
            templateType: '',
        },
        mode: 'onChange',
        resolver: yupResolver(validationSchema),
    });





    const handleUpload = async (data: any) => {
        console.log('data',"data")
        setSpinning(true);
        setUploadProgress(0);
        setUploadStatus('active');

        if (fileList.length === 0) {
            message.warning('Please select a CSV file first.');
            setSpinning(false);
            return;
        }

        const token = localStorage.getItem('loginToken');
        const institutionId = getDecodedToken()?.institutionId;
        const file = fileList[0].originFileObj || fileList[0];

        const formData = new FormData();
        formData.append('file', file);
        try {
            
            const params = new URLSearchParams({ csvTemplateId: data.templateType });
            if (institutionId !== undefined && institutionId !== null) {
                params.set('institutionId', String(institutionId));
            }
            const xhr = new XMLHttpRequest();
            xhr.open('POST', `${API_URL}/campaign/upload-initial-csv?${params.toString()}`, true);
            // xhr.open('POST', `https"//abstprizwdraw01.test.internal/be/campaign/upload-initial-csv?${params.toString()}`, true);
            xhr.setRequestHeader('Authorization', `Bearer ${token}`);

            xhr.upload.onprogress = (event) => {
                if (event.lengthComputable) {
                    const percentComplete = Math.round((event.loaded / event.total) * 100);
                    setUploadProgress(percentComplete);
                }
            };


            xhr.onload = () => {
                setSpinning(false);
                const response = JSON.parse(xhr.responseText);
                if (response.status == '00') {
                    console.log(response.status);
                    setUploadStatus('success');
                    notification.success({
                        message: 'Success',
                        description: 'File uploaded successfully.',
                    });
                    setFileList([]);
                    setBackgroundText('');
                    setUploadProgress(0);
                } else if (response.status == 401) {
                    setSpinning(false);
                    console.log(response.status);
                    setIsModalVisible(true);
                } else {
                    setUploadStatus('exception');
                    notification.error({
                        message: 'Error',
                        description: 'File upload failed. Please try again.',
                    });
                    setSpinning(false);

                }
            };

            xhr.onerror = () => {
                setSpinning(false);
                setUploadStatus('exception');
                notification.error({
                    message: 'Network Error',
                    description: `Upload failed. URL: ${API_URL}/campaign/upload-initial-csv`,
                });
            };

            xhr.send(formData);
        } catch (error) {
            setSpinning(false);
            setUploadStatus('exception');
            notification.error({
                message: 'Network Error',
                description: 'An error occurred while uploading. Please check your connection.',
            });
            console.error(error);
        }
    };




    const handleModalOk = async () => {
        setSpinning(true);
        setIsModalVisible(false);
        const token = localStorage.getItem('loginToken');
        const institutionId = getDecodedToken()?.institutionId;
        const file = fileList[0].originFileObj || fileList[0];
        const formData = new FormData();
        formData.append('file', file);
        formData.append('csvTemplateId', getValues('templateType'));

        if (action === 'override') {
            formData.append('isOverride', 'true');
        } else if (action === 'skip') {
            formData.append('isSkip', 'true');
        }

        const uploadParams = new URLSearchParams({ csvTemplateId: getValues('templateType') });
        if (institutionId !== undefined && institutionId !== null) {
            uploadParams.set('institutionId', String(institutionId));
        }

        try {
            const response = await fetch(`${API_URL}/campaign/upload-csv?${uploadParams.toString()}`, {
                method: 'POST',
                headers: {
                    'Authorization': `Bearer ${token}`,
                },
                body: formData,
            });

            if (response.ok) {
                setUploadStatus('success');
                notification.success({
                    message: 'Success',
                    description: 'File uploaded successfully.',
                });
                setFileList([]);
                setBackgroundText('');
                setUploadProgress(0);
                setSpinning(false);

            } else {
                setUploadStatus('exception');
                notification.error({
                    message: 'Error',
                    description: 'File upload failed. Please try again.',
                });
                setSpinning(false);

            }
        } catch (error) {
            setUploadStatus('exception');
            notification.error({
                message: 'Network Error',
                description: 'An error occurred while uploading. Please check your connection.',
            });
            console.error(error);
            setSpinning(false);

        }
    };




    const handleModalCancel = () => {
        setIsModalVisible(false);
    };

    const props: UploadProps = {
        name: 'file',
        multiple: true,
        accept: '.csv',
        fileList,
        showUploadList: false,
        beforeUpload(file) {
            const isCsv = file.type === 'text/csv' || file.name.endsWith('.csv');
            if (!isCsv) {
                message.error(`${file.name} is not a CSV file.`);
                return Upload.LIST_IGNORE;
            }
            setFileList([file]);
            setBackgroundText(file.name);
            return false;
        },
        onRemove() {
            setFileList([]);
            setBackgroundText('');
        },
        onDrop(e) {
            console.log('Dropped files', e.dataTransfer.files);
        },
    };

    useEffect(() => {
        const GetIDs = async () => {
            try {
                const result = await apiFetch('/campaign/getAllCsv');
                if (!result) return; // 1101 token expired - redirected
                if (result.ok) {
                    setGetIDs(result.data);
                } else {
                    console.error('Error:', result.data?.message);
                }
            } catch (error) {
                console.error(error);
            }
        };
        GetIDs();
    }, []);

    const DataArry: any = getIDs.map((field: any) => ({
        label: field.templateName,
        value: field.id,
    }));

    console.log(getIDs,'get')

    return (
        <>
            <Header />
            <Spin spinning={spinning} fullscreen />
            <div className={style.Route}>
                <h5>Upload Data</h5>
            </div>
            <div className={style.container}>
                <div style={{ marginBottom: '10px' }}>
                    <h5>Template Type</h5>
                    <FormSelect
                        control={control}
                        name='templateType'
                        options={DataArry}
                        placeholder='Select Template Type'
                        errors={errors}
                        className='form-select-container mb-1'
                        classError='form-error-message'
                        showLabel={true}
                        labelClass='form-label'
                        type='templateType'
                    />
                </div>
                <Dragger {...props}>
                    <div>
                        {uploadProgress > 0 && (
                            <Progress
                                type="circle"
                                percent={uploadProgress}
                                status={uploadStatus}
                                style={{
                                    position: 'absolute',
                                    top: '74%',
                                    left: '50%',
                                    transform: 'translate(-50%, -50%)',
                                }}
                                strokeWidth={8}
                                size={'small'}
                            />
                        )}
                    </div>
                    <div
                        className={style.drag}
                        style={{
                            background: backgroundText ? 'rgba(0, 0, 0, 0.05)' : 'transparent',
                            padding: '20px',
                            textAlign: 'center',
                        }}
                    >
                        {backgroundText ? (
                            <p
                                style={{
                                    fontSize: '32px',
                                    fontWeight: 'bold',
                                    color: '#595959',
                                }}
                            >
                                {backgroundText}
                            </p>
                        ) : (
                            <>
                                <p className="ant-upload-drag-icon">
                                    <InboxOutlined style={{ fontSize: '45px' }} />
                                </p>
                                <p className="ant-upload-text">
                                    Click or drag CSV file to this area to upload
                                </p>
                            </>
                        )}
                    </div>
                </Dragger>
                <div style={{ display: 'flex', justifyContent: 'center', marginTop: '10px' }}>
                    {hasPermission(PERMISSIONS.TRX_UPLOAD_SAVE) && (

                    <Button
                        className={style.uploadButton}
                        type="primary"
                        onClick={handleSubmit(handleUpload)}
                        disabled={fileList.length === 0}
                    >
                        Upload Data
                    </Button>
                    )}
                </div>
            </div>

            <Modal
                title="Override or Skip"
                visible={isModalVisible}
                onOk={handleModalOk}
                onCancel={handleModalCancel}
                okText="Submit"
                cancelText="Cancel"
            >
                <div>
                    <span style={{ color: "red", fontSize: "14px" }}>We Have Found Duplicate Data On File Or Data Base</span> <br />
                </div>
                <div style={{ marginTop: "10px" }}>
                    <Radio.Group
                        value={action}
                        onChange={(e) => setAction(e.target.value)}
                    >
                        <Radio value="override">Override</Radio>
                        <Radio value="skip">Skip</Radio>
                    </Radio.Group>
                </div>
            </Modal>
        </>
    );
};

export default MultiViewTable;